import { useEffect, useReducer, useState } from "react";
import {
  Box,
  Card,
  CardHeader,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import PageLoading from "../../../../components/Loading/PageLoading";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import BASEURL from "../../../../pages/Utils/Baseurl";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  allsalesorders,
  generateSalesorderPdf,
  todaySalesOrderFilterState,
  TodaySalesOrderFilterStateMange,
  updateSalesOrder,
  exportPastDateSalesOrder,
  exportTodaySalesOrder,
  pastDateSales,
  todaySalesOrder,
  pastSalesOrders,
  pastPendingSalesOrders,
  pastApprovedSalesOrders,
  allDepartmentsDropdown,
} from "../salesOrderData/salesOrderData";
import { downloadExcelFile } from "../../../function/downloadExcel";
import request from "graphql-request";
import RoleAccess from "../../../function/RoleAccess";
import { MdChangeCircle } from "react-icons/md";
import { useLoading } from "../../../../context/LodingContext";
import { PiFilePdfFill } from "react-icons/pi";
import PDFURL from "../../../../pages/Utils/pdfurl";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialSelect from "../../../../components/MasterSelect";
import Grid from "@mui/material/Grid2";
import RefreshIcon from "@mui/icons-material/Refresh";
import TableComponents from "../../../../components/tabel/index";

const SalesOrderList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [todaySalesOrderData, dispatch] = useReducer(
    TodaySalesOrderFilterStateMange,
    todaySalesOrderFilterState,
  );
  const [fromDateError, setFromDateError] = useState(null);
  const [toDateError, setToDateError] = useState(null);
  const [value, setValue] = useState(0);
  const [departmentList, setDepartmentList] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");

  const departmentOptions = [
    { value: "", label: "All Departments" },
    ...departmentList.map((dept) => ({
      value: String(dept.id),
      label: dept.departmentName,
    })),
  ];
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [dataCount, setDataCount] = useState({
    pageCount: 0,
    itemCount: 0,
  });
  const salesOrderListTable = {
    columns: [
      {
        header: "S.No",
        accessorKey: "sno",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Sales Order Id",
        accessorKey: "sio",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Customer Name",
        accessorKey: "customerName",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Department",
        accessorKey: "department",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Order Type",
        accessorKey: "orderType",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Order Date",
        accessorKey: "orderDate",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Total Amount",
        accessorKey: "totalAmount",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Status",
        accessorKey: "status",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Created By",
        accessorKey: "createdBy",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Created On",
        accessorKey: "createdOn",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
      {
        header: "Action",
        accessorKey: "Action",
        cell: (props) => <p>{props?.getValue()}</p>,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      sio: v.soNumber,
      customerName: v.customer?.customerName,
      department: v?.user?.department?.departmentName,
      orderType: v?.orderType,
      orderDate: v?.orderDate,
      totalAmount: v?.totalAmount,
      createdBy: v?.user?.employeeName + " (" + v?.user?.employeeCode + ")",
      createdOn: v?.createdAt?.slice(0, 10),
      status: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color:
                v?.status?.toLowerCase() === "pending"
                  ? "orange"
                  : v?.status?.toLowerCase() === "approved"
                    ? "#4caf50"
                    : "red",
            }}
          >
            {_.capitalize(v?.status)}
          </Typography>
          {v?.status?.toLowerCase() == "pending" && (
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleChangeStatus(v?.id)}
            />
          )}
        </Box>
      ),

      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "5px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Sales Order Screen" component="ViewSalesOrder">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/sales-order/view-sales-order`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>

          {/* <RoleAccess
            modelName="Sales Order Screen"
            component="UpdateSalesOrder"
          >
            {v?.status?.toLowerCase() == "pending" && (
              <RoleAccess
                modelName="Sales Order Screen"
                component="UpdateSalesOrder"
              >
                <EditIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() =>
                    navigate(`/sales-order/edit-sales-order`, {
                      state: { type: "edit", data: v },
                    })
                  }
                />
              </RoleAccess>
            )}
          </RoleAccess> */}

          <RoleAccess modelName="Sales Order Screen" component="PdfSalesOrder">
            <PiFilePdfFill
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDownloadPdf(v)}
            />
          </RoleAccess>

          {/* 
            <DeleteIcon
              style={{ color: "GrayText", fontSize: "20px" }}
              onClick={() => handleDelte(v?.id)}
            /> */}
        </div>
      ),
    })),
  };

  const resetFilters = () => {
    dispatch({ name: "reset" });
    setFromDateError(null);
    setToDateError(null);
    setSelectedDepartment("");
  };

  const handleDownload = () => {
    // setCirleLoading(true);
    // if (
    //   todaySalesOrderFilterState?.fromDate &&
    //   todaySalesOrderFilterState?.toDate &&
    //   value === 1
    // ) {
    //   const startDate = todaySalesOrderFilterState?.fromDate;
    //   const endDate = todaySalesOrderFilterState?.toDate;
    //   request(BASEURL, exportPastDateSalesOrder, { startDate, endDate }).then(
    //     async (res) => {
    //       const status = res?.exportPastProduct?.success;
    //       const pdfurl = `${URL}${res?.exportPastProduct?.fileUrl?.slice(1)}`;
    //       if (status) {
    //         const status = await downloadExcelFile(
    //           pdfurl,
    //           "filter_sales_order.xlsx",
    //         );
    //         setCirleLoading(false);
    //       }
    //     },
    //   );
    // } else {
    //   request(BASEURL, exportTodaySalesOrder).then(async (res) => {
    //     const status = res?.exportTodayProduct?.success;
    //     const message = res?.exportTodayProduct?.message;
    //     const pdfurl = `${URL}${res?.exportTodayProduct?.fileUrl?.slice(1)}`;
    //     if (status) {
    //       const status = await downloadExcelFile(pdfurl, "Today_Product.xlsx");
    //       setCirleLoading(false);
    //     } else {
    //       setCirleLoading(false);
    //       Swal.fire({
    //         position: "top",
    //         icon: "error",
    //         title: message,
    //         showConfirmButton: true,
    //       });
    //     }
    //   });
    // }
  };
  const handleChange = (event, newValue) => {
    setData([]);
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setValue(newValue);
    resetFilters();
  };

  // Fetch departments once on mount
  useEffect(() => {
    request(BASEURL, allDepartmentsDropdown)
      .then((res) => {
        if (res?.allDepartmentsDropdown?.success) {
          setDepartmentList(res.allDepartmentsDropdown.data || []);
        }
      })
      .catch(() => { });
  }, []);

  const fetchPastPendingSalesOrder = async () => {
    setIsLoading(true);
    try {
      const variables = {
        ...(todaySalesOrderData?.fromDate && {
          startDate: todaySalesOrderData.fromDate,
        }),
        ...(todaySalesOrderData?.toDate && {
          endDate: todaySalesOrderData.toDate,
        }),
        ...{
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        },
        ...(selectedDepartment && { departmentId: selectedDepartment }),
      };
      const res = await request(BASEURL, pastPendingSalesOrders, variables);

      if (res?.pendingSalesOrders?.success) {
        setData(res?.pendingSalesOrders?.data);
        setDataCount({
          pageCount: res?.pendingSalesOrders?.totalPages,
          itemCount: res?.pendingSalesOrders?.totalCount
        })
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPastApprovedSalesOrder = async () => {
    setIsLoading(true);
    try {
      const variables = {
        ...(todaySalesOrderData?.fromDate && {
          startDate: todaySalesOrderData.fromDate,
        }),
        ...(todaySalesOrderData?.toDate && {
          endDate: todaySalesOrderData.toDate,
        }),
        ...{
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
        },
        ...(selectedDepartment && { departmentId: selectedDepartment }),
      };
      const res = await request(BASEURL, pastApprovedSalesOrders, variables);

      if (res?.approvedSalesOrders?.success) {
        setData(res?.approvedSalesOrders?.data);
        setDataCount({
          pageCount: res?.approvedSalesOrders?.totalPages,
          itemCount: res?.approvedSalesOrders?.totalCount
        })
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {

    if (value === 0) {
      fetchtodaySalesOrder();
    } else if (value === 1) {
      if (fromDateError || toDateError) return;
      fetchPastPendingSalesOrder();
    } else {
      fetchPastApprovedSalesOrder();
    }
  }, [value, pagination, todaySalesOrderData, selectedDepartment]);

  useEffect(() => {
    const validateDates = (fromDate, toDate) => {
      const today = new Date();
      const fromDateObj = new Date(fromDate);
      const toDateObj = new Date(toDate);

      const errors = {
        fromDateError: null,
        toDateError: null,
      };

      if (fromDateObj > today) {
        errors.fromDateError = "From Date cannot be greater than today's date.";
      }

      if (toDateObj > today) {
        errors.toDateError = "To Date cannot be greater than today's date.";
      }

      if (toDateObj < fromDateObj) {
        errors.toDateError = "To Date cannot be earlier than From Date.";
      }

      return errors;
    };

    if (todaySalesOrderData?.fromDate || todaySalesOrderData?.toDate) {
      const { fromDateError, toDateError } = validateDates(
        todaySalesOrderData.fromDate,
        todaySalesOrderData.toDate,
      );

      setFromDateError(fromDateError);
      setToDateError(toDateError);
    } else {
      setFromDateError(null);
      setToDateError(null);
    }
  }, [todaySalesOrderData?.fromDate, todaySalesOrderData?.toDate]);

  const fetchtodaySalesOrder = async () => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, todaySalesOrder, {
        page: pagination.pageIndex + 1,
        pageSize: pagination.pageSize,
        ...(selectedDepartment && { departmentId: selectedDepartment }),
      });

      if (res?.todaySalesOrders?.success) {
        setData(res?.todaySalesOrders?.data);
        setDataCount({
          pageCount: res?.todaySalesOrders?.totalPages,
          itemCount: res?.todaySalesOrders?.totalCount
        })
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = async (orderId) => {
    const { value: formValues, isConfirmed } = await Swal.fire({
      title: "Change Status",
      html: `
        <div style="overflow-x:hidden; width:100%; box-sizing:border-box;">
          <div style="text-align:left; margin-bottom:12px;">
            <label style="font-weight:600; display:block; margin-bottom:6px; font-size:14px;">Select Status</label>
            <select id="swal-status" style="width:100%; padding:9px 10px; border:1px solid #d9d9d9; border-radius:6px; font-size:14px; box-sizing:border-box; outline:none; background:#fff; cursor:pointer;">
              <option value="">-- Select a status --</option>
              <option value="Approved">Approve</option>
              <option value="Rejected">Reject</option>
            </select>
          </div>
          <div id="swal-reason-wrapper" style="text-align:left; display:none;">
            <label style="font-weight:600; display:block; margin-bottom:6px; font-size:14px;">Rejection Reason <span style="color:red">*</span></label>
            <textarea id="swal-reason" placeholder="Enter rejected reason..." style="width:100%; min-height:90px; padding:9px 10px; border:1px solid #d9d9d9; border-radius:6px; font-size:14px; box-sizing:border-box; resize:vertical; outline:none; font-family:inherit;"></textarea>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      focusConfirm: false,
      didOpen: () => {
        const statusEl = document.getElementById("swal-status");
        const reasonWrapper = document.getElementById("swal-reason-wrapper");
        statusEl.addEventListener("change", () => {
          reasonWrapper.style.display =
            statusEl.value === "Rejected" ? "block" : "none";
        });
      },
      preConfirm: () => {
        const status = document.getElementById("swal-status").value;
        const reason = document.getElementById("swal-reason").value?.trim();
        if (!status) {
          Swal.showValidationMessage("Please select a status!");
          return false;
        }
        if (status === "Rejected" && !reason) {
          Swal.showValidationMessage("Please enter a rejection reason!");
          return false;
        }
        return { status, reason: status === "Rejected" ? reason : null };
      },
    });

    if (!isConfirmed || !formValues) return;

    const { status, reason: rejectedReason } = formValues;

    setCirleLoading(true);
    try {
      const payload = {
        salesOrderId: Number(orderId),
        status: status,
      };

      if (status === "Rejected" && rejectedReason) {
        payload.rejectedReason = rejectedReason;
      }

      const res = await request(BASEURL, updateSalesOrder, {
        input: payload,
      });

      const success = res?.updateSalesOrder?.success;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "Status Changed Successfully",
          showConfirmButton: true,
        }).then(() => {
          if (value === 0) {
            fetchtodaySalesOrder();
          } else if (value === 1) {
            fetchPastPendingSalesOrder();
          } else {
            fetchPastApprovedSalesOrder();
          }
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDownloadPdf = async (data) => {
    setCirleLoading(true);

    try {

      const res = await request(BASEURL, generateSalesorderPdf, {
        id: Number(data?.id),
      });

      const success = res?.generateSalesorderPdf?.success;
      const message = res?.generateSalesorderPdf?.message;
      const pdfUrl = `${PDFURL}${res?.generateSalesorderPdf?.pdfUrl}`;

      if (success && pdfUrl) {
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download",
          `${data?.soNumber || "Sales_Order"}_${data?.customer?.customerName || ""}.pdf`
        );

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error downloading PDF:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {value === 0 ? "Today's Sales Order List" : value === 1 ? "Past Pending Sales Order List" : "Past Approved Sales Order List"}
                  </MaterialTypography>
                </Stack>

                <RoleAccess
                  modelName="Sales Order Screen"
                  component="CreateSalesOrder"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      navigate("/sales-order/add-sales-order", {
                        state: { type: "add" },
                      })
                    }
                  >
                    Sales Order
                  </MaterialButton>
                </RoleAccess>
              </Stack>
              <Box sx={{ marginTop: "16px", marginBottom: "8px" }}>
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "stretch", md: "center" }}
                  spacing={2}
                >
                  <Box sx={{ bgcolor: "background.paper", borderRadius: "8px" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#2a9941",
                          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.66)",
                        },
                      }}
                      centered
                      sx={{
                        "& .MuiTab-root": {
                          fontSize: "15px",
                          minHeight: "40px",
                          textTransform: "none",
                          padding: "6px 12px",
                        },
                      }}
                    >
                      <Tab
                        disabled={isLoading}
                        label="Today Sales Order List"
                      />
                      <Tab
                        disabled={isLoading}
                        label="Past Pending Sales Order List"
                      />
                      <Tab
                        disabled={isLoading}
                        label="Past Approved Sales Order List"
                      />
                    </Tabs>
                  </Box>

                  {/* Department Dropdown - visible on all tabs */}
                  <Box sx={{ minWidth: 240, width: { xs: "100%", md: 260 }, position: "relative", zIndex: 10 }}>
                    <MaterialBox lineHeight={0} display="inline-block" mb={0.5}>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Department
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      placeholder="All Departments"
                      value={
                        selectedDepartment
                          ? departmentOptions.find(
                            (opt) => String(opt.value) === String(selectedDepartment)
                          ) || null
                          : null
                      }
                      options={departmentOptions}
                      onChange={(option) => {
                        setSelectedDepartment(option?.value || "");
                        setPagination({ pageIndex: 0, pageSize: pagination.pageSize });
                      }}
                      isClearable
                      size="small"
                      customStyles={{ optionPadding: 10 }}
                      menuPosition="fixed"
                    />
                  </Box>
                </Stack>

                {value !== 0 && (
                  <Box
                    sx={{
                      mt: 2,
                      p: 1.5,
                      bgcolor: "#f8f9fa",
                      borderRadius: "8px",
                      border: "1px solid #e9ecef",
                    }}
                  >
                    <Grid container spacing={2} alignItems="center">
                      <Grid size={{ xs: 12, sm: 5 }}>
                        <MaterialBox lineHeight={0} display="inline-block" mb={0.5}>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            From Date
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="date"
                          size="small"
                          name="fromDate"
                          value={todaySalesOrderData?.fromDate}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "fromDate",
                            })
                          }
                        />
                        {fromDateError && (
                          <MaterialTypography
                            color="error"
                            variant="caption"
                            display="block"
                            mt={0.5}
                          >
                            {fromDateError}
                          </MaterialTypography>
                        )}
                      </Grid>
                      <Grid size={{ xs: 12, sm: 5 }}>
                        <MaterialBox lineHeight={0} display="inline-block" mb={0.5}>
                          <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                          >
                            To Date
                          </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                          type="date"
                          size="small"
                          name="toDate"
                          value={todaySalesOrderData?.toDate}
                          onChange={(e) =>
                            dispatch({
                              value: e?.target?.value,
                              name: "toDate",
                            })
                          }
                        />
                        {toDateError && (
                          <MaterialTypography
                            color="error"
                            variant="caption"
                            display="block"
                            mt={0.5}
                          >
                            {toDateError}
                          </MaterialTypography>
                        )}
                      </Grid>
                      <Grid size={{ xs: 12, sm: 2 }}>
                        <IconButton
                          onClick={resetFilters}
                          aria-label="Reset Filters"
                          color="primary"
                          sx={{ mt: 2 }}
                        >
                          <RefreshIcon fontSize="large" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Box>
            </>
          }
        />
        <Box sx={{ mt: 2, px: 1, pb: 2, }}>
          {!isLoading && (
            <TableComponents
              rows={salesOrderListTable?.rows}
              columns={salesOrderListTable?.columns}
              pagination={pagination}
              setPagination={setPagination}
              pageCount={dataCount.pageCount}
              recordCount={dataCount.itemCount}
              isLoading={isLoading}
              isSearch={false}
            />
          )}
          {isLoading && <PageLoading />}
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default SalesOrderList;
